import React, { useState, useMemo } from 'react'
import Header from '../Header'
import Sidebar from '../Sidebar'
import { Link } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react/build/FeatherIcon'
const PatientBMI = () => {
  
  const [weight, setWeight] = useState(40);
  const [height, setHeight] = useState(140);
  
  const getWeight = (e) => {
    setWeight(e.target.value);
  }
  const getHeight = (e) => {
    setHeight(e.target.value)
  }
  const CalculateBMI = useMemo(() => {
    let heightinmeter = height / 100;
    return weight / (heightinmeter * heightinmeter);
  });
  return (
    <>
     <Header/>
     <Sidebar/>
     <div className='page-wrapper'>
      <div className='content'>
      <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">
                    BMI Status
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className='card'>
            <div className='card-body'>
              <div className='card-title'>
                Body Mass Index
              </div>
             
                <div>
                <label>Weight : {weight}</label>
                <input type='range' className='form-range' value={weight}  min={0} max={100} onChange={getWeight} />
                </div>
                <div>
                  <label>Height : {height}</label>
                  <input type='range' className='form-range' value={height}  min={0} max={220} onChange={getHeight} />
                </div>
                <div>
                  <span>Your BMI Status{" "}</span>
                  <span>{CalculateBMI}</span>
                </div>
              
            </div>
          </div>
      </div>
    </div>
    </>
  )
}

export default PatientBMI
